import type {
  ContactCardGridFragment as ContactCardGridQueryResponse,
  MndContact,
} from '@mnd-apps/public/wp-generated/types';
import CardContact from '@mnd-frontend/ui/public/components/CardContact';
import CardsAligner from '@mnd-frontend/ui/public/components/wrappers/CardsAligner';
import ContentMaxWidth from '@mnd-frontend/ui/public/components/wrappers/ContentMaxWidth';
import SectionHeader from '@mnd-frontend/ui/public/components/wrappers/SectionHeader';
import { BREAKPOINTS, SPACING_2, SPACING_6, SPACING_10 } from '@mnd-frontend/ui/shared/tokens';
import styled from 'styled-components';

const ModuleContainer = styled.section`
  background-color: #F7F7F9;
  padding: ${SPACING_6} ${SPACING_2};
  
  @media (min-width: ${BREAKPOINTS.MD}px) {
    padding-top: ${SPACING_10};
    padding-bottom: ${SPACING_10};
  }
  
  @media (min-width: ${BREAKPOINTS.XXL}px) {
    padding-right: 0;
    padding-left: 0;
  }
`;

const formatContactImage = (item: MndContact | null) => ({
  width: 960,
  height: 540,
  alt: '',
  src: item?.image ?? '',
  id: (item?.name ?? 'profile').split(' ').join(''),
});

const ContactCardGridModule = ({ moduleData }: { moduleData: ContactCardGridQueryResponse }) => (
  <ModuleContainer>
    <ContentMaxWidth>
      <SectionHeader headline={moduleData.title} />
      <CardsAligner>
        {moduleData.data?.map((item, index) => (
          <CardContact
            key={(item?.name ?? `profile-${index}`).split(' ').join('')}
            label={item?.name}
            subtext1={item?.subText1}
            subtext2={item?.subText2}
            image={formatContactImage(item)}
          />
        ))}
      </CardsAligner>
    </ContentMaxWidth>
  </ModuleContainer>
);

export default ContactCardGridModule;
